/* src/app/modules/search/components/doc-view/components/attachment-view/attachment-view.component.scss */
.attachment_container .menu ::ng-deep .menuitem-content {
  padding: 0.5rem 0.5rem;
}
/*# sourceMappingURL=attachment-view.component.css.map */
